import { useToggle } from '../../../infra/small-tools/use-toggle';
export var useReorderState = function (props) {
    var lockReorderToggle = useToggle(false);
    return {
        isReorderLocked: lockReorderToggle.isOn,
        toggleIsReorderLocked: function () { return lockReorderToggle.toggle(); },
        canReorder: props.clientFilter === '' && !lockReorderToggle.isOn,
    };
};
